var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_262)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_262",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.343 7.5855C18.9806 8.49884 19.4121 9.53988 19.6075 10.6365H22V13.3635H19.6075C19.4121 14.4601 18.9806 15.5012 18.343 16.4145L20.0355 18.107L18.107 20.0355L16.4145 18.343C15.5012 18.9806 14.4601 19.4121 13.3635 19.6075V22H10.6365V19.6075C9.53988 19.4121 8.49884 18.9806 7.5855 18.343L5.893 20.0355L3.9645 18.107L5.657 16.4145C5.01937 15.5012 4.58791 14.4601 4.3925 13.3635H2V10.6365H4.3925C4.58791 9.53988 5.01937 8.49884 5.657 7.5855L3.9645 5.893L5.893 3.9645L7.5855 5.657C8.49884 5.01937 9.53988 4.58791 10.6365 4.3925V2H13.3635V4.3925C14.4601 4.58791 15.5012 5.01937 16.4145 5.657L18.107 3.9645L20.0355 5.893L18.343 7.5855Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.8df91fe1522658436808a8b06d2c9212.svg";
export { ForwardRef as ReactComponent };